<template>
    <form method="post" @submit.prevent="submitForm">
        <input type="hidden" name="InventoryRequestId" v-model="InventoryRequestId"/>
        <inventory-request-edit-item-list
            ref="inventoryRequestObject"
            :inventory-request-id="InventoryRequestId"
            :new-items="newItems"
            :IsSupplyChain="IsSupplyChain"
            :IsWarehouse="IsWarehouseApproved"
        >

        </inventory-request-edit-item-list>
        <div class="text-center">
            <input type="submit" class="btn btn-success btn-sm w-25" value="Save Inventory Request"/>
            <!-- <a href="#" v-if="IsSupplyChainApproved" class="btn btn-primary btn w-25">Add Issued Quantity</a> -->
        </div>
    </form>
</template>
<script>
    import InventoryRequestEditItemList from './InventoryRequestEditItemList.vue'
    export default {
        name : 'inventory-request-edit-form',
        props: ['newItems', 'InventoryRequestId', 'IsSupplyChain', 'IsSupplyChainApproved', 'IsWarehouseApproved'],
        components: {
            'inventory-request-edit-item-list' : InventoryRequestEditItemList
        },
        data(){
            return {
                formData : {
                    data : null
                },
                URLpurchaseOrderUpdateItem: 'inventory-requests/items/store',

            }
        },
        methods:{
            submitForm: function(){
                this.formData.data = this.$refs.inventoryRequestObject.itemrows


                var unique = this.checkUniqueItems(this.$refs.inventoryRequestObject.itemrows, 'ItemId')
                this.$refs.inventoryRequestObject.itemrows = unique;

                // show message if duplicated items
                this.formData.data.map(v => v.ItemId).sort().sort((a, b) => {
                    if (a === b) alert("We have removed duplicated items")
                })
                this.formData.data = this.$refs.inventoryRequestObject.itemrows;
                this.formData['InventoryRequestId'] =  this.InventoryRequestId;
                this.formData['IsSupplyChain'] =  this.IsSupplyChain ? true : false;
                axios.post(this.URLpurchaseOrderUpdateItem, this.formData)
                    .then(response => {
                        if(response.data.success != 1){

                        } else {
                            Swal.fire({
                                title: 'Submitted Successfully',
                                icon: 'success',
                            })

                            this.$refs.inventoryRequestObject.callItemsFromApi(this.InventoryRequestId)
                        }

                    }).
                catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },

            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            }
        }
    }
</script>
